import { styled } from '@mui/material'

export const ReadonlyViolationIcon = styled('span', { name: 'ReadonlyViolationIcon' })`
  position: relative;
  display: inline-block;
  margin-left: 4px;
  width: 10px;
  color: ${p => p.theme.palette.warning.main};
`
